class HeaderNavbar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttonsWithTarget = this.querySelectorAll('button[data-target]');

    this.buttonsWithTarget.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));

    this.querySelector('#overlay-backdrop').addEventListener('click', this.onOverlayBackdropClick.bind(this));

    this.onKeyDownHandler = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyDownHandler, false);

    this.createScrollObserver();

    this.MenuDisclosureButtons = this.querySelectorAll('.MenuDisclosure button');
    this.MenuDisclosureButtons.forEach((button) => button.addEventListener('click', this.onDisclosureClick.bind(this)));
  }

  createScrollObserver() {
    let observer = new IntersectionObserver((entries, _observer) => {
      if (entries[0].isIntersecting) {
        this.querySelector('#navbar-primary .Navbar-symbolIcon')?.classList.remove('is-active');
        this.querySelector('#navbar-primary .Navbar-beboIcon')?.classList.add('is-active');
      } else {
        this.querySelector('#navbar-primary .Navbar-symbolIcon')?.classList.add('is-active');
        this.querySelector('#navbar-primary .Navbar-beboIcon')?.classList.remove('is-active');
      }
    });

    observer.observe(this.querySelector('#navbar-spacer'));
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    const target = button.dataset.target;
    const expanded = button.ariaExpanded !== 'true';

    this.buttonsWithTarget.forEach((button) => {
      if (button.ariaExpanded == 'true') {
        button.ariaExpanded = false;
        this.hideTarget(button.dataset.target);
      }
    });

    button.ariaExpanded = expanded;
    if (expanded) {
      this.showTarget(target);
    }
  }

  showTarget(target) {
    this.querySelector(target).ariaHidden = false;
    document.querySelector('body').classList.add('has-overlay', 'is-locked', 'has-navigation');
  }

  hideTarget(target) {
    this.querySelector(target).ariaHidden = true;
    document.querySelector('body').classList.remove('has-overlay', 'is-locked', 'has-navigation');
  }

  closeAll() {
    this.buttonsWithTarget.forEach((button) => {
      if (button.ariaExpanded == 'true') {
        button.ariaExpanded = false;
        this.hideTarget(button.dataset.target);
      }
    });
  }

  onOverlayBackdropClick(_event) {
    this.closeAll();
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.closeAll();
    }
  }

  onDisclosureClick(event) {
    let button = event.currentTarget;

    button.closest('.MenuDisclosure').classList.toggle('is-active');
  }
}

customElements.define('header-navbar', HeaderNavbar);
